// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2cuK_","buttons":"styles_buttons__3dfSn"};